module.exports = __webpack_public_path__ + "static/img/kent.96b337d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/team/kent.jpg
// module id = 56
// module chunks = 0